import React from "react"
import styled from "@emotion/styled"

import Phil from "../../images/phil.png"

const Outer = styled.section`
  display: grid;
  grid-template-columns:
    minmax(32px, auto) minmax(auto, ${props => props.theme.maxWidth})
    minmax(32px, auto);
  padding: 96px 0 0 0;
  background: ${props => props.theme.shade[90]};
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    grid-template-columns: 24px auto 24px;
  }
`
const Inner = styled.div`
  grid-column: 2;
  display: grid;
  grid-template-columns: 1.5fr 1fr;
  gap: 32px;
  align-items: center;
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    grid-template-columns: 1fr;
  }
`
const Content = styled.div`
  margin-bottom: 96px;
  ul {
    list-style: none;
    position: relative;
  }

  ul li:before {
    position: absolute;
    left: -24px;
    font-weight: 600;
    content: "✓";
  }
  ul li {
  }
`
const ImageContainer = styled.div`
  /* @media (max-width: ${props => props.theme.breakpoints.md}) {
    display: none;
  } */
  display: grid;
  margin-top: auto;
`
const PhilImg = styled.img`
  margin: 0;
`

export default function HighlightFeature({ content }) {
  return (
    <Outer>
      <Inner>
        <Content>{content}</Content>
        <ImageContainer>
          <PhilImg src={Phil} alt="Phil founder of Userfy" />
        </ImageContainer>
      </Inner>
    </Outer>
  )
}
